import React, { useEffect, useState } from "react";
import { auth, db } from "../firebase/firebase";
import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { useAuth } from "./AuthContext";
import { useNavigate } from "react-router-dom";
import PagePreview from "./PagePreview";

function Dashboard() {
  const [pages, setPages] = useState([]);
  const { currentUser } = useAuth();
  const [error, setError] = useState("");
  const [selectedPage, setSelectedPage] = useState(null);
  const [userDocExists, setUserDocExists] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPages = async () => {
      try {
        if (!currentUser) {
          setError("Kein Benutzer angemeldet.");
          return;
        }

        const userRef = doc(db, "users", currentUser.uid);
        const userDoc = await getDoc(userRef);

        if (!userDoc.exists()) {
          setUserDocExists(false); // Benutzer-Dokument fehlt → Button anzeigen
          return;
        }

        setUserDocExists(true);

        const userData = userDoc.data();
        const userPages = userData.pages || [];
        const pageArray = [];

        for (const userPage of userPages) {
          const pageDoc = await getDoc(doc(db, "pages", userPage));
          if (pageDoc.exists()) {
            pageArray.push({
              id: userPage,
              link: pageDoc.data().link,
              name: pageDoc.data().name || null,
            });
          }
        }

        setPages(pageArray);
      } catch (err) {
        setError(err.message);
      }
    };

    fetchPages();
  }, [currentUser]);

  const createUserDocAndRedirect = async () => {
    try {
      const userRef = doc(db, "users", currentUser.uid);
      const userSnap = await getDoc(userRef);
  
      // Dokument nur anlegen, wenn es noch nicht existiert
      if (!userSnap.exists()) {
        await setDoc(userRef, {
          email: currentUser.email,
          createdAt: serverTimestamp(),
          role: "user",
          pages: [],
        });
      }
  
      navigate("/add-qr-code");
    } catch (err) {
      setError("Fehler beim Erstellen des Benutzerdokuments: " + err.message);
    }
  };
  

  return (
    <div className="container">
      <div className="dropdown mb-4 mt-4 d-flex justify-content-center">
        <button
          className="btn btn-secondary dropdown-toggle"
          type="button"
          id="pageDropdown"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          {selectedPage
            ? selectedPage.name
              ? selectedPage.name
              : `Seite ${selectedPage.link}`
            : "Seite auswählen"}
        </button>
        <ul className="dropdown-menu" aria-labelledby="pageDropdown">
          {/* ✅ Wenn UserDoc existiert: Seiten anzeigen */}
          {userDocExists && pages.map((page) => (
            <li key={page.id}>
              <button
                className="dropdown-item"
                onClick={() => setSelectedPage(page)}
              >
                {page.name ? page.name : `Seite ${page.link}`}
              </button>
            </li>
          ))}

          {/* ✅ QR-Code hinzufügen immer ganz unten */}
          <li>
            <hr className="dropdown-divider" />
          </li>
          <li>
            <button
              className="dropdown-item text-primary fw-bold"
              onClick={createUserDocAndRedirect}
            >
              QR-Code hinzufügen
            </button>
          </li>
        </ul>
      </div>


      {selectedPage && <PagePreview page={selectedPage} />}

      {error && <p className="text-danger text-center mt-3">{error}</p>}
    </div>
  );
}

export default Dashboard;
